import { StrictMode } from "react";
import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import { Home } from "./pages/Home";
import { SignInPage } from "./pages/SignIn";

/*
 * The pages built to plain HTML at build time (prerender.tsx) and hydrated
 * on load (main.tsx) without the router: "/" and "/signin". The same tree on
 * both sides, so hydration matches.
 */
export const STATIC_PAGES = { home: Home, signin: SignInPage } as const;
export type StaticPage = keyof typeof STATIC_PAGES;
export const isStaticPage = (p: string | undefined): p is StaticPage => p === "home" || p === "signin";

export function StaticTree({ page, client }: { page: StaticPage; client: QueryClient }) {
  const Page = STATIC_PAGES[page];
  return <StrictMode><QueryClientProvider client={client}><Page /></QueryClientProvider></StrictMode>;
}
